interface ImprintTranslations {
  pageTitle: string;
  authorizedRepresentatives: string;
  boardOfDirectors: string;
  registerEntry: string;
  registeredCompanyName: string;
  companyNo: string;
  vatNumber: string;
  registerNumber: string;
  disclaimer: string;
  disclaimerText: string[];
  disclaimerForLinks: string;
  disclaimerForLinksText: string;
  copyright: string;
  copyrightText: string;
  phone: string;
  email: string;
}

export const imprintTemplateTranslations: Record<string, ImprintTranslations> = {
  en: {
    pageTitle: "IMPRINT",
    authorizedRepresentatives: "Authorised representative(s)",
    boardOfDirectors: "Board of Directors",
    registerEntry: "Commercial register entry",
    registeredCompanyName: "Registered company name",
    companyNo: "Company no. (UID)",
    vatNumber: "VAT number",
    registerNumber: "Commercial register number",
    disclaimer: "Disclaimer",
    disclaimerText: [
      "The author assumes no liability whatsoever with regard to the correctness, accuracy, up-to-dateness, reliability and completeness of the information.",
      "Liability claims regarding damage caused by the use of any information provided, including any kind of information which is incomplete or incorrect, will therefore be rejected.",
      "All offers are non-binding. The author expressly reserves the right to change, supplement or delete parts of the pages or the entire offer without special notice or to cease publication temporarily or permanently."
    ],
    disclaimerForLinks: "Disclaimer for links",
    disclaimerForLinksText: "References and links to third party websites are outside our area of responsibility. Any responsibility for such websites is disclaimed. The access and use of such websites is at the risk of the respective user.",
    copyright: "Copyright",
    copyrightText: "The copyrights and all other rights to the content, images, photos or other files on this website belong exclusively to Realization Desal AG or the specifically named rights holders. The written consent of the copyright holders must be obtained in advance for the reproduction of any elements.",
    phone: "Phone",
    email: "E-Mail"
  },
  de: {
    pageTitle: "IMPRESSUM",
    authorizedRepresentatives: "Vertretungsberechtigte(r)",
    boardOfDirectors: "Vorstand",
    registerEntry: "Eintrag im Handelsregister",
    registeredCompanyName: "Eingetragener Firmenname",
    companyNo: "Firmen-Nr. (UID)",
    vatNumber: "Umsatzsteuer-Identifikationsnummer",
    registerNumber: "Handelsregisternummer",
    disclaimer: "Haftungsausschluss",
    disclaimerText: [
      "Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.",
      "Haftungsansprüche, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.",
      "Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen."
    ],
    disclaimerForLinks: "Haftungsausschluss für Links",
    disclaimerForLinksText: "Verweise und Links auf fremde Internetseiten liegen außerhalb unseres Verantwortungsbereiches. Jegliche Verantwortung für solche Websites wird abgelehnt. Der Zugriff und die Nutzung solcher Websites erfolgt auf eigenes Risiko des jeweiligen Nutzers.",
    copyright: "Urheberrecht",
    copyrightText: "Die Urheberrechte und alle anderen Rechte an den Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich der Realization Desal AG oder den namentlich genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist vorgängig die schriftliche Zustimmung der Urheberrechtsinhaber einzuholen.",
    phone: "Telefon",
    email: "E-Mail"
  }
}; 